import { Store } from '../services';

export class TopLevelWithoutHeaderComponent {

    constructor(public store: Store) {
        this._showHeader(false);
    }

    componentDestroy() {
        this._showHeader(true);
    }

    private _showHeader(show: boolean) {
        setTimeout(() => this.store.pushAppEvent({ type: 'hideHeader', data: show }), 0);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/top-level-without-header.component.ts